var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrownSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "crown-solid",
    d: "M16,3a2.995,2.995,0,0,0-1.437,5.625L11.625,14.5,7.031,11.219a3.031,3.031,0,1,0-2.875.625L6,22v5H26V22l1.844-10.156a2.95,2.95,0,1,0-2.875-.625L20.375,14.5,17.438,8.625A2.995,2.995,0,0,0,16,3Zm0,2a1,1,0,1,1-1,1A.987.987,0,0,1,16,5ZM5,8A1,1,0,1,1,4,9,.987.987,0,0,1,5,8ZM27,8a1,1,0,1,1-1,1A.987.987,0,0,1,27,8ZM16,10.25l3.094,6.188,1.5.375,5-3.562L24.188,21H7.813L6.406,13.25l5,3.563,1.5-.375ZM8,23H24v2H8Z",
    transform: "translate(-2 -3)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownSolid);
export default __webpack_public_path__ + "static/media/crown-solid.c6212be89deea08cb635b9a6da7a66fb.svg";
export { ForwardRef as ReactComponent };